import React, { useState } from 'react';
import { Icon, Row, Col, DatePicker } from "antd";
import moment from 'moment';
import CardGeneralHolder from "./Styles/cardGeneralStyle";
import { useTranslation } from 'react-i18next';
import 'moment/locale/es';
import 'moment/locale/en-gb';
import ModalChangeDates from './ModalChangeDates';
import { syncRulesWithCampaignDates } from '../services/utils';

const CardGeneralComponent = (props) => {
  const { t, i18n } = useTranslation();
  const {
    editCampaignActive,
    currentCampaign,
    date_from,
    date_to,
    setDates,
    programmatic,
    stepsCurrent,
    libraryRules,
    setLibraryRules,
    customContents,
    updateCustomContents
  } = props;

  const [endOpen, setEndOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleConfirmSync = () => {
    const syncLib = syncRulesWithCampaignDates(libraryRules || [], date_from, date_to)
    const syncCustom = syncRulesWithCampaignDates(customContents || [], date_from, date_to)
    if (syncLib.rulesCount > 0) {
      setLibraryRules(syncLib.updatedContents)
    }
    if (syncCustom.rulesCount > 0) {
      updateCustomContents(syncCustom.updatedContents)
    }
    setIsModalVisible(false)
  }

  const disabledDateEnd = (endValue) => {
    if (!endValue || !date_from) {
      return false;
    }
    return endValue.isBefore(date_from);
  };


  const disabledDateStart = (startValue) => {
    if (!startValue) return false;
    // Allow any date from today onwards, without forcing the relationship with date_to
    return startValue.isBefore(moment().startOf('day'));
  };

  const handleStartOpenChange = (open) => {
    if (!open) {
      setEndOpen(true);
    }
  };

  const handleEndOpenChange = (open) => {
    setEndOpen(open);
  };

  const disabledDate = editCampaignActive
    ? currentCampaign.payment_status === "approved"
    : false;

  return (
    <CardGeneralHolder hasRedistribute={programmatic === "programmatic" && stepsCurrent > 1}>
      <div className="cardGeneral">
        <Row justify="center">
          <Col>
            <div className="calendar-container">
              <div className='contentDate'>
                <div className='infoDate'>{t("Start date")}</div>
                <DatePicker
                  allowClear={false}
                  value={moment(date_from)}
                  format={i18n.language === 'en' ? "MM-DD-YYYY" : "DD-MM-YYYY"}
                  suffixIcon={<Icon type="down" />}
                  onChange={(date) => {
                    const newFrom = date.format("YYYY-MM-DD")
                    const newTo = moment(date_to).isBefore(date) ? newFrom : date_to
                    setDates(newFrom, newTo)
                  }}
                  onOpenChange={handleStartOpenChange}
                  disabledDate={disabledDateStart}
                  disabled={disabledDate}
                  className='datePicker'
                />
              </div>
              <div className='contentDate'>
                <div className='infoDate'>{t("Finish date")}</div>
                <DatePicker
                  allowClear={false}
                  value={moment(date_to)}
                  format={i18n.language === 'en' ? "MM-DD-YYYY" : "DD-MM-YYYY"}
                  suffixIcon={<Icon type="down" />}
                  onChange={(date) => {
                    const newFrom = moment(date_from).isAfter(date) ? date.format("YYYY-MM-DD") : date_from
                    const newTo = date.format("YYYY-MM-DD")
                    setDates(newFrom, newTo)
                    const syncLib = syncRulesWithCampaignDates(libraryRules || [], newFrom, newTo)
                    const syncCustom = syncRulesWithCampaignDates(customContents || [], newFrom, newTo)
                    if (syncLib.rulesCount + syncCustom.rulesCount > 0) {
                      setIsModalVisible(true);
                    }
                  }}
                  open={endOpen}
                  onOpenChange={handleEndOpenChange}
                  disabledDate={disabledDateEnd}
                  disabled={disabledDate}
                  className='datePicker'
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <ModalChangeDates
        visible={isModalVisible}
        onCancel={handleConfirmSync}
      />
    </CardGeneralHolder>
  );
};

export default CardGeneralComponent;